
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { PaymentService } from "../../../../../landing/src/utility/payment/PaymentService";
import { NotificationStore } from "../../../../../common/src/stores/NotificationStore";
import { Api } from "../../../../../common/src/api/Api";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { PointOfContact } from "@gsx/common";
import SubscriptionUpgrade from "./SubscriptionUpgrade.vue";

@Component({
    components: {
        SubscriptionUpgrade,
        LoadingOverlay,
    },
})
export default class TeamOwnership extends Vue {
    @Inject("container") readonly container!: Container;
    readonly organizationStore: OrganizationStore = this.container.get(OrganizationStore);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly api: Api = this.container.get(Api);
    readonly paymentService: PaymentService = this.container.get(PaymentService);
    readonly authStore: AuthStore = this.container.get(AuthStore);

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        return this.organizationStore.item;
    }

    get hasOwnershipAttr() {
        return (
            this.organization?.foreignOwnership ||
            this.organization?.ownership ||
            this.organization?.numEmployees ||
            this.organization?.subsidiary ||
            this.organization?.foreignFunding ||
            this.organization?.parentOrganizationName
        );
    }

    get publicPointOfContacts() {
        const uniqueKeys = new Set();
        const publicPointOfContacts = this.organization?.pointOfContact?.filter(
            (poc: PointOfContact) => poc.publicInfo,
        );
        const filteredContacts = publicPointOfContacts?.filter((contact) => {
            const uniqueKey = `${contact.firstName} ${contact.lastName}`;
            if (!uniqueKeys.has(uniqueKey)) {
                uniqueKeys.add(uniqueKey);
                return true;
            } else {
                return false;
            }
        });

        return filteredContacts;
    }
}
